<template lang="pug">
  .advance-settings
    v-container.px-0(style="max-width:600px")
      v-layout.my-2
        div.mr-2
          v-icon.mt-1(left color="black" :size="24" @click="$router.push('/admin/clinic/settings')") mdi-arrow-left
        div.title.font-weight-bold {{ $t('analytics') }}
      v-card.py-4.mt-4(flat outlined)
              .header.px-4
                div.s1.basic800--text {{ $t('section_integrations.analytics') }}
                div.c1.basic600--text {{ $t('section_integrations.analytics_desc') }}
                div.c1.accent--text(@click="openLink('a')") {{ $t('learn_more') }}

              v-divider.my-4
              v-layout.mx-4.mt-4
                div.my-auto
                  v-card.elevation-0
                    v-img(:src="require('@/assets/images/settings/logo_facebook_pixel.svg')" width=28)
                div.my-auto.ml-3.s1.basic800--text Facebook Pixel
                v-spacer
                v-chip.button-AA-tiny.text-uppercase(label outlined color="black" small @click="openTrackerDialog('fb')") {{ $t('manage') }}
              v-divider.my-4
              v-layout.mx-4.mt-4
                div.my-auto.ml-1
                  v-card.elevation-0
                    v-img(:src="require('@/assets/images/settings/logo_analytics.svg')" width=19 contain)
                div.my-auto.ml-4.s1.basic800--text Google Analytics
                v-spacer
                v-chip.button-AA-tiny.text-uppercase(label outlined color="black" small @click="openTrackerDialog('ga')") {{ $t('manage') }}
              v-divider.my-4
              v-layout.mx-4.mt-4
                div.my-auto.ml-1
                  v-card.elevation-0
                    v-img(:src="require('@/assets/images/settings/logo_tiktok_pixel.svg')" width=26)
                div.my-auto.ml-3.s1.basic800--text Tiktok Pixel
                v-spacer
                v-chip.button-AA-tiny.text-uppercase(label outlined color="black" small @click="openTrackerDialog('tiktok')") {{ $t('manage') }}
      

    .modals
      update-trackers(v-if="showUpdateTrackersDialog" :open.sync="showUpdateTrackersDialog" :company.sync="company" :type="openTrackerType")
      update-webhook(v-if="showUpdateWebhookDialog" :open.sync="showUpdateWebhookDialog" :company="company")
      request-custom-domain(v-if="openRequestCustDomain" :open.sync="openRequestCustDomain" :company="company")
      domain-verifications(v-if="openDomainVerifications" :open.sync="openDomainVerifications" :company="company")

</template>

<script>
import { mapActions } from 'vuex'
import UpdateTrackers from '@/components/dialogs/settings/UpdateTrackers.vue'
import UpdateWebhook from '@/components/dialogs/settings/UpdateWebhook.vue'
import RequestCustomDomain from '@/components/dialogs/RequestCustomDomain.vue'
import DomainVerifications from '@/components/dialogs/DomainVerifications.vue'
import OnlinePaymentList from '@/components/settings/OnlinePaymentList.vue'
import DeliveryChargeList from '@/components/dialogs/settings/DeliveryChargeList.vue'
import DeliveryZoneList from '@/components/dialogs/settings/DeliveryZoneList.vue'

export default {
  name: 'AdvanceConfigurationSettings',
  components: { UpdateTrackers, UpdateWebhook, RequestCustomDomain, DomainVerifications, OnlinePaymentList, DeliveryChargeList, DeliveryZoneList },
  props: ['company'],
  data () {
    return {
      paymentExpansionPanels: undefined,
      showUpdateTrackersDialog: false,
      showUpdateWebhookDialog: false,
      openRequestCustDomain: false,
      openDomainVerifications: false,
      openTrackerType: '',
      ecommerce: [
        { title: 'WooCommerce', image: require('@/assets/images/settings/logo_woocommerce.svg'), link: '/admin/settings/woocommerce', action: 'router-push' },
        // { title: 'Magento', image: require('@/assets/images/magento-logo-square.png'), link: '/admin/settings/woocommerce', action: 'dialog' },
        { title: 'Shopify', image: require('@/assets/images/settings/logo_shopify.svg'), link: '/admin/settings/shopify', action: 'router-push' },
      ],
      openManageDeliveryZoneDialog: false,
      couriers: []
    }
  },
  mounted () {
    this.fetchShippingSettings()
    this.handleClickFromYezzaPayNoticeBanner()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    openLink (link) {
      if (link === 'w') {
        window.open('https://guide.yezza.io/eng/tips-use-webhook/')
      } else if (link === 'a' ) {
        window.open('https://help.yezza.io/hc/en-my/sections/900000600066-Analytics')
      } else if (link === 'p' ) {
        window.open('https://help.yezza.io/hc/en-my/categories/900000227246-Accept-Payments')
      } else {
        window.open('https://help.yezza.io/hc/en-my/articles/900003297906-How-To-Integrate-Yezza-With-WooCommerce-')
      }
    },
    setUp (path) {
      if (!this.Auth('root', 'e_commerce_integrations')) {
        this.showMessage(['upgrade'])
        return
      }
      this.$router.push(path)
    },
    openTrackerDialog (type) {
      this.openTrackerType = type
      this.showUpdateTrackersDialog = true
    },
    openWebhookDialog () {
      //this.openTrackerType = type
      this.showUpdateWebhookDialog = true
    },
    toggleCourier(courier) {
      const data = {'enabled': this.couriers[courier].enabled}
      this.axios.patch(`/shipping/settings/${this.company.slug}/${courier}`, data)
        .then(() => {
          const shipments = {
            easyparcel: this.couriers.easyparcel.enabled,
            zepto: this.couriers.zepto.enabled,
            lalamove: this.couriers.lalamove.enabled,
            yscourier: false,
            yslocaldelivery: false
          }
          this.$store.commit('orders/setShipments', shipments)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    openCourier (courier) {
      if (courier === 'easyparcel') {
        this.$router.push('/admin/settings/easyparcel')
      } else if (courier === 'zepto') {
        this.$router.push('/admin/settings/zeptoexpress')
      } else if (courier === 'lalamove') {
        this.$router.push('/admin/settings/lalamove')
      }
    },
    getAvailability (index) {
      return this.couriers[index].available
    },
    fetchShippingSettings () {
      this.$axios.get(`/shipping/settings/${this.company.slug}`).then((response) => {
        this.couriers = response.data.couriers
      },()=>{})
    },
    handleClickFromYezzaPayNoticeBanner () {
      if (this.$store.state.ui.securepayMigrateModal) {
        this.paymentExpansionPanels = 0
      }
      this.$watch('$store.state.ui.securepayMigrateModal', (val) => {
        if (val) {
          this.paymentExpansionPanels = 0
        }
      })
    }
  }
}
</script>

<i18n>
{
  "en": {
    "section_integrations": {
      "title": "Integrations",
      "desc": "Analytics, e-commerce integrations, domain, webhook",
      "analytics": "Analytics",
      "analytics_desc": "Analyze and measure your business performance",
      "ecommerce_integration": "E-commerce Integrations",
      "ecommerce_integration_desc": "Integrate with your current e-commerce system",
      "domain": "Domain",
      "domain_desc": "Manage your domain for Whatsapp Form and Yezza Store",
      "custom_domain": "Custom Domain",
      "domain_verifications": "Domain Verifications",
      "webhook": "Webhook",
      "webhook_desc": "Webhook setting for API integration"
    },
    "section_shipping": {
      "title": "Shipping and delivery",
      "desc": "Manage zones, courier and on-demand integrations",
      "manage_shipping": "Manage shipping & delivery methods by zones",
      "manage_shipping_desc": "Manage shipping & delivery methods by zones",
      "manage_shipping_disabled": "Shipping and delivery integrations are disabled because Yezza Shipping is activated.",
      "courier_integration": "Courier Integration",
      "courier_integration_desc": "Take advantage of courier services that can easily be integrated with your Yezza account",
      "ondemand": "On-Demand Delivery Integration",
      "ondemand_desc": "Take advantage of on-demand delivery services that can easily integrated with your Yezza account."
    },
    "courier_description": {
      "easyparcel": "Hub for major courier services like PosLaju, DHL etc.",
      "lalamove": "On-Demand service delivery in Malaysia",
      "zepto": "On-Demand service delivery in Malaysia"
    },
    "section_payment": {
      "title": "Payment",
      "desc": "Third party payment gateways",
      "payment_gateway": "Payment Gateway",
      "payment_gateway_desc": "Activate your choice of payment gateway"
    }
  },
  "id": {
    "section_integrations": {
      "title": "Integrasi",
      "desc": "Analisa, integrasi e-commerce, domain, webhook",
      "analytics": "Analisis",
      "analytics_desc": "Analisis dan ukur performa bisnis kamu",
      "ecommerce_integration": "Integrasi E-commerce",
      "ecommerce_integration_desc": "Integrasikan dengan sistem e-commerce kamu saat ini",
      "domain": "Domain",
      "domain_desc": "Atur domain kamu untuk Whatsapp Form dan Yezza Store",
      "custom_domain": "Domain Khusus",
      "domain_verifications": "Verifikasi Domain",
      "webhook": "Webhook",
      "webhook_desc": "Pengaturan Webhook untuk integrasi API"
    },
    "section_shipping": {
      "title": "Pengiriman",
      "desc": "Atur zona, kurir dan integrasi on-demand",
      "manage_shipping": "Atur shipping & delivery berdasarkan zona",
      "manage_shipping_desc": "Atur shipping & delivery berdasarkan zona",
      "manage_shipping_disabled": "Integrasi pengiriman dan pengiriman dinonaktifkan karena Yezza Shipping diaktifkan.",
      "courier_integration": "Integrasi Kurir",
      "courier_integration_desc": "Manfaatkan layanan kurir yang mudah diintegrasikan dengan akun Yezza kamu",
      "ondemand": "Integrasi Pengiriman Sesuai Permintaan",
      "ondemand_desc": "Manfaatkan layanan pengiriman sesuai permintaan yang dengan mudah diintegrasikan dalam akun Yezza kamu."
    },
    "courier_description": {
      "easyparcel": "Hub untuk layanan kurir utama seperti PosLaju, DHL dll.",
      "lalamove": "Pengiriman layanan sesuai permintaan di Malaysia",
      "zepto": "Pengiriman layanan sesuai permintaan di Malaysia"
    },
    "section_payment": {
      "title": "Pembayaran",
      "desc": "Portal Pembayaran Third Party",
      "payment_gateway": "Portal Pembayaran",
      "payment_gateway_desc": "Aktifkan portal pembayaran pilihan kamu"
    }
  }
}
</i18n>
